import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class ExternalReports extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.externalReports, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
